import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import { TitleCase } from "../../common";

class CheckboxField extends Component {
  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChange(val, e) {
    this.props.onChange(this.props.repeatingForm, this.props.element_id, val);
  }

  renderField() {
    const {
      element_prompt,
      validate,
      error,
      element_value,
      ...formControl
    } = this.props;

    let val = formControl.element_params.Y;

    if (element_value === val) {
      val = formControl.element_params.N;
      return (
        <div className="check" onClick={this.handleChange.bind(this, val)}>
          <div className="checkMark active">
            <i className="checkmark icon"></i>
          </div>
          {formControl.element_optional === "1"
            ? TitleCase(element_prompt)
            : TitleCase(element_prompt) + " *"}
        </div>
      );
    }

    if (validate && error) {
      return (
        <div className="checkError" onClick={this.handleChange.bind(this, val)}>
          <div className="checkMark">
            <i className="checkmark icon"></i>
          </div>
          {formControl.element_optional === "1"
            ? TitleCase(element_prompt)
            : TitleCase(element_prompt) + " *"}
        </div>
      );
    }

    return (
      <div className="check" onClick={this.handleChange.bind(this, val)}>
        <div className="checkMark">
          <i className="checkmark icon"></i>
        </div>
        {formControl.element_optional === "1"
          ? TitleCase(element_prompt)
          : TitleCase(element_prompt) + " *"}
      </div>
    );
  }

  render() {
    return (
      <div className="formControlItem">
        <Form.Field>{this.renderField()}</Form.Field>
      </div>
    );
  }
}

CheckboxField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default CheckboxField;



// WEBPACK FOOTER //
// ./src/components/CheckboxField/index.js